<template>
  <div class="flex relative z-20 justify-between mt-8">
    <ul v-if="projectSwiper">
      <li v-for="i in 3" class="inline-block mr-1" :key="i">
        <button type="button" class="w-10 h-10 rounded-full border border-black cormorant font-semibold text-2xl flex justify-center items-center pb-2 mr-1" :class="projectSwiper.activeIndex === i-1? 'bg-lemon-normal': 'bg-white'" @click="slideTo(i-1)">
          {{ i }}
        </button>
      </li>
    </ul>
    <ul>
      <li class="inline-block mr-1">
        <button type="button" class="w-10 h-10 rounded-full border border-black bg-white flex justify-center items-center" @click="clickPrev">
          <svg class="mr-1" style="width:14px;height:14px" viewBox="0 0 24 24">
            <polygon fill="currentColor" points="3,12 24,0 24,24" />
          </svg>
        </button>
      </li>
      <li class="inline-block mr-1">
        <button type="button" class="w-10 h-10 rounded-full border border-black bg-white cormorant font-semibold flex justify-center items-center" @click="clickNext">
          <svg class="rotate-180 ml-1" style="width:14px;height:14px" viewBox="0 0 24 24">
            <polygon fill="currentColor" points="3,12 24,0 24,24" />
          </svg>
        </button>
      </li>
    </ul>
  </div>
  <div class="-mx-5 mt-8">
    <swiper
      :slides-per-view="1"
      @swiper="onSwiper"
    >
      <swiper-slide>
        <div>
          <img class="w-full h-auto" :src="publickPath + '/images/staff-1.jpg'">
          <div class="px-5 -mt-14">
              <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">南船場店</span></p>
              <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">店長 / 安井 英樹</span></h5>
              <p class="text-sm font-bold mt-6 leading-6">
                  チェントに居て、入って、仕事して良かったこと、嬉しかったことは？
              </p>
              <p class="mt-6 leading-7">
                  メンバーやお客様と“出会え、築けた関係性”。メンバーにもお客さまにも愛があり、思いやりや優しさに溢れ、お客さまと販売員を超えた友人のような関わり方ができる会社ですね。
              </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div>
          <img class="w-full h-auto" :src="publickPath + '/images/staff-2.jpg'">
          <div class="px-5 -mt-14">
              <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">阪急メンズ大阪店</span></p>
              <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">店長 / 佐渡川 梨沙</span></h5>
              <p class="text-sm font-bold mt-6 leading-6">
                チェントの何に価値を感じこの場所にいるのですか？
              </p>
              <p class="mt-6 leading-7">
                チェントは“セラピー”。皆さん元気になりに来てくださる。人生を変えてくれるくらいの、“新しい扉”を開くお手伝いを、みんなと一緒にワクワクしながら、お客さまにとっての正解を作っていけることが楽しくて、働いているのだと思います。
              </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div>
          <img class="w-full h-auto" :src="publickPath + '/images/staff-3.jpg'">
          <div class="px-5 -mt-14">
              <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">本社</span></p>
              <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">WEB担当 / 冨本 耕司</span></h5>
              <p class="text-sm font-bold mt-6 leading-6">
                チェントってどんな会社ですか？
              </p>
              <p class="mt-6 leading-7">
                “イキリたい”を叶え、服を通じて“体験”を想像させてくれる場所。 自分らしく仕事を楽しめるかどうかは、自分次第。「こうなりたい」とか「これをやりたい」、その気持ちを考えているだけでなく、口に出して実行していく。それができる会社なんだと思います。
              </p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { ref } from 'vue';
import { computed } from '@vue/reactivity';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const projectSwiper = ref(null);
    const onSwiper = (swiper) => {
      projectSwiper.value = swiper;
    };
    const clickNext = () => {
        projectSwiper.value.slideNext()
    }
    const clickPrev = () => {
        projectSwiper.value.slidePrev()
    }
    const slideTo = (index) => {
      projectSwiper.value.slideTo(index)
    }

    const publickPath = computed(() => {
      if (process.env.NODE_ENV === 'production') {
        return '/recruit'
      } else {
        return ''
      }
    })
    return {
      onSwiper,
        publickPath,
        projectSwiper,
        clickNext,
        clickPrev,
        slideTo
    }
  }
}
</script>
